<template>
  <!-- TODO: ???: check if meeting notifications sent (disable inputs if so) -->
  <div>
    <b-row class="steps-tunnel justify-content-center">
      <b-col cols="12" md="8">
        <b-row>
          <!-- step1 btn -->
          <b-col cols="auto step-btn-block ym-auto">
            <div class="step-text">Immeuble</div>
            <b-button
              class="button btn-step"
              :class="{ 'btn-step-active': currentStep == 1 }"
              @click="changeStep(1)"
            >
              1
            </b-button>
          </b-col>
          <b-col class="step-line my-auto"></b-col>
          <!-- step2 btn -->
          <b-col cols="auto step-btn-block my-auto">
            <div class="step-text">Date/Lieu</div>
            <b-button
              class="button btn-step"
              :class="{ 'btn-step-active': currentStep == 2 }"
              :disabled="!step1ok && isNew"
              @click="changeStep(2)"
            >
              2
            </b-button>
          </b-col>
          <b-col class="step-line my-auto"></b-col>
          <!-- step3 btn -->
          <b-col cols="auto step-btn-block my-auto">
            <div class="step-text">Résolutions</div>
            <b-button
              class="button btn-step"
              :class="{ 'btn-step-active': currentStep == 3 }"
              :disabled="!step2ok && isNew"
              @click="changeStep(3)"
            >
              3
            </b-button>
          </b-col>
          <b-col class="step-line my-auto"></b-col>
          <!-- step4 btn -->
          <b-col cols="auto step-btn-block my-auto">
            <div class="step-text">Visiteurs</div>
            <b-button
              class="button btn-step"
              :class="{ 'btn-step-active': currentStep == 4 }"
              :disabled="!step3ok && isNew"
              @click="changeStep(4)"
            >
              4
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- .. -->
    <div v-if="!isLoadingInit">
      <appStep1
        v-if="currentStep == 1"
        ref="step-1"
        :meeting="meeting"
        :buildings-options="buildingsOptions"
        :voting-categories="meeting.voting_categories"
        @updateMeeting="updateMeeting"
      />
      <appStep2
        v-if="currentStep == 2"
        ref="step-2"
        :meeting="meeting"
        @updateMeeting="updateMeeting"
      />
      <appStep3
        v-if="currentStep == 3"
        :meeting-id="meeting.id"
        :building-id="meeting.building_id"
        @hideParentActionButtons="hideActionButtons = $event"
      />
      <appStep4
        v-if="currentStep == 4"
        :meeting-id="meeting.id"
        :building-id="meeting.building_id"
        @hideParentActionButtons="hideActionButtons = $event"
      />

      <!-- cancel, create, update -->
      <b-row v-if="!hideActionButtons" class="mt-5 mb-2 justify-content-center">
        <b-col cols="auto">
          <b-button class="button btn-red" @click="cancel">
            <font-awesome-icon class="agv-button-icon" icon="times-circle" />
            <span>{{ $t("general.cancel") }}</span>
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button
            v-if="isNew && currentStep !== 4"
            :disabled="isLoadingSave"
            class="button btn-blue"
            @click="goToNextStep"
          >
            <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="arrow-right" />
            <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
            <span>{{ $t("general.continue") }}</span>
          </b-button>
          <b-button
            v-else
            :disabled="isLoadingSave"
            class="button btn-blue"
            @click="UPDATE_MEETING"
          >
            <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="save" />
            <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
            <span>{{ $t("general.enregistrer") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </div>
    <appLoader v-else />
  </div>
</template>

<script>
import { validate } from "vee-validate";

import appStep1 from "./Step1";
import appStep2 from "./Step2";
import appStep3 from "./Step3";
import appStep4 from "./Step4";

import MeetingMW from "@/middlewares/Meeting";
import MeetingORM from "@/store/orm-axios/models/Meeting";

import BuildingMW from "@/middlewares/Building";
import BuildingORM from "@/store/orm-axios/models/Building";

export default {
  components: {
    appStep1,
    appStep2,
    appStep3,
    appStep4,
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modify: true,
      initialMeeting: null,
      currentStep: 1,
      step1ok: false,
      step2ok: false,
      step3ok: false,
      hideActionButtons: false,
      isLoadingInit: true,
      isLoadingSave: false,
      meeting: {
        agency_id: Number(localStorage.getItem("agencyId")),
        // licence_id: 1, // ???: ..
        // minutes_media_id: 1,
        // presence_media_id: 1,
        // invitation_media_id: 1,
        allowed_modalities: {
          physical: false,
          correspondence: false,
          video: false,
        },
        last_reception_date: null,
        building_id: null,
        name: "",
        meeting_date: new Date(),
        address: "",
        access: "",
        minutes: [], // ???: ..
        freezed_meeting_details: [], // ???: ..
        status: 0, // status chenged to 0 from 1
        meeting_room_name: null,
        isExternalVideoSolutionUsed: false,
        show_connection_details: false,
        votes_need_recalculations: 0,
        voting_categories: [],
        send_invitation_files_to_asl_co_owners: false,
        send_pv_files_to_asl_co_owners: false,
        // mandates: [],
        // resolutions: [],
      },
    };
  },
  computed: {
    buildingsOptions() {
      return BuildingORM.query().where("agency_id", this.agencyId).orderBy("created", "desc").get();
    },
    meetingStatusORM() {
      if (this.meeting.id) {
        return MeetingORM.find(this.meeting.id).status;
      } else {
        return 0;
      }
    },
    timezone() {
      return localStorage.getItem("timezone");
    },
  },
  watch: {
    meetingStatusORM(newVal, oldVal) {
      // NOTE: set status to mandates created when it's changing
      if (newVal == this.meetingStatuses.mandatesCreated) {
        this.meeting.status = newVal;
      }
    },
    // meeting: {
    //   handler(val, oldVal) {
    //// console.log("oldVal", oldVal);
    //// console.log("newval", val);
    //     // console.log(this.$_.isEqual(val, oldVal));
    //     if (
    //       val.allowed_modalities.physical == false &&
    //       val.allowed_modalities.video == false &&
    //       val.allowed_modalities.correspondence == false
    //     ) {
    //       this.allowedPresenceError(oldVal);
    //     }
    //   },
    //   deep: true,
    // },
    meeting: {
      handler(newVal) {
        if (newVal.building_id) {
          const building = this.buildingsOptions.find(item => item.id == newVal.building_id);
          if (building && !building.asl) {
            this.meeting.send_invitation_files_to_asl_co_owners = false;
            this.meeting.send_pv_files_to_asl_co_owners = false;
          }
        }
      },
      deep: true,
    },
  },
  async created() {
    try {
      if (this.$route.params.step) {
        this.currentStep = this.$route.params.step;
      }

      if (!this.isNew) {
        await MeetingMW.GET(this.$route.params.id).then(() => {
          this.meeting = MeetingORM.query()
            .where("id", this.$route.params.id)
            .withAllRecursive()
            .first();
          this.initialMeeting = JSON.parse(JSON.stringify(this.meeting));
        });
      }

      const buildingProperties = [
        "id",
        "name",
        "agency_id",
        "created",
        { votingCategories: ["id", "name", "is_charge_generale"] },
        "asl",
      ];
      await BuildingMW.QUERY_FETCH_PROPERTIES(this.agencyId, buildingProperties);

      if (this.timezone) {
        this.$moment.tz.setDefault(this.timezone);
      }

      this.isLoadingInit = false;
    } catch (err) {
      this.isLoadingInit = false;
      console.error(err);
      this.$swal(this.alertError());
    }
  },
  mounted() {
    // EX: position steps tunnel texts
    this.setStepTextsStyles();
  },
  methods: {
    allowedPresenceError(oldVal) {
      this.$swal({
        icon: "error",
        title: "Nous devons avoir une modalité de participation activée!",
        showConfirmButton: false,
        timer: 5000,
      }).then(() => {
        this.meeting.allowed_modalities.physical = true;
      });
    },
    updateMeeting(key, value) {
      if (this.meeting.id) {
        MeetingORM.update({
          where: this.meeting.id,
          data(item) {
            item[key] = value;
          },
        });
      }
      this.meeting[key] = value;
    },
    async validateStep() {
      var valid = true;
      if (this.currentStep == 1) {
        await validate(this.meeting.name, "required", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-1"].$refs["vee-meeting-name"].validate();
          }
        });
        await validate(this.meeting.building_id, "required", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-1"].$refs["vee-meeting-building_id"].validate();
          }
        });
      }
      if (this.currentStep == 2) {
        await validate(this.meeting.meeting_date, "required", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-2"].$refs["vee-meeting-meeting_date"].validate();
          }
        });
        if (this.meeting.allowed_modalities.physical) {
          await validate(this.meeting.address, "required", {}).then(res => {
            if (!res.valid) {
              valid = false;
              this.$refs["step-2"].$refs["vee-physique-first-address"].validate();
            }
          });
        }
        if (
          this.meeting.external_video_solution != null ||
          this.meeting.isExternalVideoSolutionUsed
        ) {
          await validate(this.meeting.external_video_solution, "required", {}).then(res => {
            if (!res.valid) {
              valid = false;
              this.$refs["step-2"].$refs["vee-meeting-external-video-solution"].validate();
            }
          });
        }
      }
      return valid;
    },
    async changeStep(stepNb) {
      if (!(await this.validateStep())) {
        return;
      }
      this.currentStep = stepNb;
    },
    async goToNextStep() {
      if (!(await this.validateStep())) {
        return;
      }

      if (this.currentStep == 2 && !this.meeting.id) {
        this.checkDateAndAllowedModalityes().then(res => {
          if (res) {
            this.CREATE_MEETING();
          }
        });
      } else if (this.currentStep == 2 && this.meeting.id) {
        this.checkDateAndAllowedModalityes().then(res => {
          if (res) {
            this.step2ok = true;
            this.changeStep(3);
          }
        });
      } else {
        if (this.currentStep == 1) this.step1ok = true;
        if (this.currentStep == 2) this.step2ok = true;
        if (this.currentStep == 3) this.step3ok = true;
        this.currentStep++;
      }
    },
    cancel() {
      this.$router.push({ name: "meetings" });
    },
    async CREATE_MEETING() {
      this.isLoadingSave = true;
      MeetingMW.POST(this.meeting)
        .then(res => {
          this.isLoadingSave = false;
          this.meeting = MeetingORM.query().where("id", res.id).withAllRecursive().first();
          this.goToNextStep();
        })
        .catch(err => {
          this.isLoadingSave = false;
          console.log("err", err);
        });
    },
    async checkDateAndAllowedModalityes() {
      var ok = true;
      if (!this.meeting.allowed_modalities.physical) {
        this.meeting.address = null;
        this.meeting.access = null;
      }
      if (
        this.meeting.allowed_modalities.physical == false &&
        this.meeting.allowed_modalities.video == false &&
        this.meeting.allowed_modalities.correspondence == false
      ) {
        this.currentStep == 2;
        this.changeStep(2);
        await this.$swal({
          icon: "error",
          title: "Nous devons avoir une modalité de participation activée!",
          showConfirmButton: false,
          timer: 2500,
        }).then(async () => {
          if (this.meeting.meeting_date == null) {
            this.changeStep(2);
            await this.$swal({
              icon: "error",
              title: "La date de la réunion est obligatoire",
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              ok = false;
              return false;
            });
          }
          ok = false;
        });
      } else if (this.meeting.meeting_date == null) {
        this.changeStep(2);
        await this.$swal({
          icon: "error",
          title: "La date de la réunion est obligatoire",
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          ok = false;
          return false;
        });
      }
      return ok;
    },
    async UPDATE_MEETING() {
      if (!(await this.validateStep())) {
        return;
      }
      var x = await this.checkDateAndAllowedModalityes();
      if (!x) {
        return;
      }
      // to update last reception date
      this.isLoadingSave = true;
      this.isLoadingInit = true;
      MeetingMW.PUT(this.meeting)
        .then(async meeting => {
          this.isLoadingSave = false;
          this.$router.push({ name: "meetings" });
          this.isLoadingInit = false;
        })
        .catch(err => {
          this.isLoadingSave = false;
          this.isLoadingInit = false;
          console.log("err", err);
        });
    },
  },
};
</script>
